import { Navigate } from 'react-router';

import { useAuthContext } from '../hooks/useAuthContext';

interface RoleBasedGuardProps {
  requiredRoles?: string[];
  requiredPermissions?: string[];
  children: React.ReactNode;
}

function RoleBasedGuard({ requiredRoles, requiredPermissions, children }: RoleBasedGuardProps) {
  const { hasRoles, hasPermissions } = useAuthContext();

  if (requiredRoles && !hasRoles(requiredRoles)) return <Navigate to="/403" />;
  if (requiredPermissions && !hasPermissions(requiredPermissions)) return <Navigate to="/403" />;

  return children;
}

export default RoleBasedGuard;
